import { ProductType } from '@sparelabs/api-client'

export type EngageProductType = ProductType.Eligibility | ProductType.Resolve

export const DEFAULT_ENGAGE_PRODUCT: EngageProductType = ProductType.Eligibility
